import { events, device } from "@utilities";
import { CLASSNAMES } from "@constants";

/**
 * Handle Mega menu
 *
 * @param container {HTMLElement} container element
 */

export default (container: HTMLElement) => {
  const items = [...container.getElementsByClassName("js-menuItem")];
  const logins = [...container.getElementsByClassName("js-login")];
  const segment = document.querySelector(".js-menuBg");
  const overlay = document.querySelector(".js-menuOverlay");

  const closeMenu = () => {
    items.forEach((item: HTMLElement) => {
      const { target } = item.dataset;
      const inner = document.getElementById(target);
      item.classList.remove(CLASSNAMES.IS_OPEN);
      inner.classList.remove(CLASSNAMES.ACTIVE);
      item.setAttribute("aria-expanded", "false");
    });
    container.classList.remove(CLASSNAMES.IS_OPEN);
    segment?.classList.remove(CLASSNAMES.IS_OPEN);
    overlay?.classList.remove("overlay");
  };

  const openMenu = (item: HTMLElement) => {
    const { target } = item.dataset;
    const inner = document.getElementById(target);
    item.classList.add(CLASSNAMES.IS_OPEN);
    inner.classList.add(CLASSNAMES.ACTIVE);
    item.setAttribute("aria-expanded", "true");
    container.classList.add(CLASSNAMES.IS_OPEN);
    segment?.classList.add(CLASSNAMES.IS_OPEN);
    overlay?.classList.add("overlay");
  };

  const toggleMenu = (item: HTMLElement) => {
    if (item.classList.contains(CLASSNAMES.IS_OPEN)) {
      closeMenu();
    } else {
      closeMenu();
      openMenu(item);
    }
  };

  logins.forEach((link: HTMLElement) => {
    const { target } = link.dataset;
    const inner = document.getElementById(target);
    if (target) {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        inner.classList.toggle(CLASSNAMES.ACTIVE);
        link.classList.toggle(CLASSNAMES.IS_OPEN);
        link.setAttribute(
          "aria-expanded",
          link.getAttribute("aria-expanded") === "true" ? "false" : "true"
        );

        closeMenu();
      });
    }
    document.body.addEventListener("mousedown", (event) => {
      if (link.classList.contains(CLASSNAMES.IS_OPEN)) {
        const isClickInsideLoginMenu = inner.contains(<Node>event?.target);
        const isClickInsideLoginMenuLink = link.contains(<Node>event?.target);
        if (!isClickInsideLoginMenu && !isClickInsideLoginMenuLink) {
          inner.classList.remove(CLASSNAMES.ACTIVE);
          link.classList.remove(CLASSNAMES.IS_OPEN);
          link.setAttribute("aria-expanded", "false");
        }
      }
    });
  });

  items.forEach((item: HTMLElement) => {
    events.on(item, {
      click: (event) => {
        event.preventDefault();
        toggleMenu(item);
      },
    });
  });

  const megaMenu = document.querySelector(".js-megaMenu");
  document.body.addEventListener("mousedown", (event) => {
    if (megaMenu.classList.contains(CLASSNAMES.IS_OPEN)) {
      const isClickInsideMenu = megaMenu.contains(<Node>event?.target);
      if (!isClickInsideMenu) {
        closeMenu();
      }
    }
  });

  window.onkeydown = (event) => {
    if (megaMenu.classList.contains(CLASSNAMES.IS_OPEN)) {
      const { key } = event;
      if (key === "Escape") {
        closeMenu();
      }
    }
  };

  if (device.isDesktopBreakpoint()) {
    window.onscroll = () => {
      if (document.documentElement.scrollTop > 200) {
        closeMenu();
      }
    };
  }
};
